<template>
  <ProgramSearchPage :filter-fields="filterFields" />
</template>

<script>
import { mapState } from 'vuex'
import ProgramSearchPage from '~contemporaryTheme/pages/programs/index'

export default {
  components: {
    ProgramSearchPage,
  },
  computed: {
    ...mapState('departments', {
      chosenDepartments: (state) => state.chosen || state.all,
    }),
    filterFields() {
      return [
        {
          label: 'Departments',
          placeholder: 'Filter By Departments',
          questionId: 'departments',
          dataKey: 'departments',
          custom: false,
          inputType: 'searchSelect',
          config: {
            options: this.departmentOptions,
          },
          visibility: true,
          tooltipEnabled: false,
          filter: {
            group: 'program',
            id: 'departments-programs',
            inputType: 'select',
            name: 'departments',
            type: 'is',
          },
        },
        {
          label: 'Degree Designation',
          questionId: 'degreeDesignation',
          dataKey: 'degreeDesignation',
          custom: false,
          type: 'radio',
          questionType: 'select',
          config: {
            showAllOptions: true,
          },
          visibility: true,
          tooltipEnabled: false,
          filter: {
            group: 'program',
            id: 'degreeDesignation-programs',
            inputType: 'select',
            name: 'degreeDesignation',
            type: 'is',
          },
        },
      ]
    },
    departmentOptions() {
      return this.chosenDepartments.map((item) => {
        return { label: item.displayName, value: item.id }
      })
    },
  },
}
</script>
